import { PERMISSIONS } from './enums/permissions.enum';
import { ItemMenu } from './models';
import { STRUCT_CAP_URL_ROOT } from '../modules/crm/struct-cap-crm/struct-cap-crm-parent/struct-cap-crm-parent.component';
import { CONFIG } from '../config';


export const MENU: Array<ItemMenu> = [
  {
    textKey: 'MENU.PORTFOLIO',
    icon: 'caret-down',
    permissionsNeeded: [PERMISSIONS.CorePortfolioRead],
    subMenu: []
  },
  {
    textKey: 'MENU.HEADLINES',
    link: '/headlines',
    icon: '',
    permissionsNeeded: [PERMISSIONS.HeadlinesRead],
    subMenu: null
  },
  {
    textKey: 'MENU.PRC_VOL_MOVERS',
    link: '/price-volume-movers',
    icon: '',
    permissionsNeeded: [PERMISSIONS.CorePriceVolumeMoversRead],
    subMenu: null
  },
  {
    textKey: 'MENU.PRC_TARGETS',
    link: '/price-targets',
    icon: '',
    permissionsNeeded: [PERMISSIONS.CorePriceTargetRead],
    subMenu: null
  },
  {
    textKey: 'MENU.SONAR',
    icon: 'caret-down',
    permissionsNeeded: [PERMISSIONS.SonarRead],
    subMenu: [
      {
        textKey: 'MENU.SONAR',
        link: `/sonar`,
        icon: '',
        permissionsNeeded: [PERMISSIONS.SonarRead]
      },
      {
        textKey: 'MENU.STRUCT_CAP',
        link: `/sonar/${STRUCT_CAP_URL_ROOT}`,
        icon: '',
        permissionsNeeded: [PERMISSIONS.SonarRead]
      }
    ]
  },
  {
    textKey: 'MENU.STORM',
    link: '/company-dashboard/storm',
    icon: '',
    permissionsNeeded: [PERMISSIONS.ExecDashboardRead],
    subMenu: null
  },
  {
    textKey: 'MENU.IBBXBI',
    link: '/portfolio/indexes',
    icon: '',
    permissionsNeeded: [PERMISSIONS.CoreFundingsRead],
    subMenu: null
  },
  // Temporarily hidden. Uncomment to restore the Tara nav item (the /tara route in
  // app-routing.module.ts is commented out alongside it and must come back too).
  // {
  //   textKey: 'MENU.TARA',
  //   link: '/tara',
  //   icon: '',
  //   permissionsNeeded: [PERMISSIONS.AiGptNotesRead],
  //   subMenu: null
  // },
  {
    textKey: 'MENU.QRS_LINKS',
    icon: 'caret-down',
    permissionsNeeded: [
      PERMISSIONS.QrsRead
    ],
    subMenu: []
  },
  {
    textKey: 'MENU.RESEARCH',
    icon: 'caret-down',
    permissionsNeeded: [
      PERMISSIONS.CoreCompaniesDashboardRead,
      PERMISSIONS.CoreMilestonesRead,
      PERMISSIONS.CoreIndicationsRead,
      PERMISSIONS.CoreInsightsRead,
      PERMISSIONS.CoreAttachmentsRead,
      PERMISSIONS.TradeRestrictionRead,
      PERMISSIONS.BoardRestrictionRead
    ],
    subMenu: [
      {
        textKey: 'MENU.MILESTONES',
        link: '/milestones',
        icon: '',
        permissionsNeeded: [PERMISSIONS.CoreMilestonesRead]
      },
      {
        textKey: 'MENU.INDICATIONS',
        link: '/indications',
        icon: '',
        permissionsNeeded: [PERMISSIONS.CoreIndicationsRead]
      },
      {
        textKey: 'MENU.COMPANY_DASHBOARD',
        link: '/company-dashboard',
        icon: '',
        permissionsNeeded: [PERMISSIONS.ExecDashboardRead]
      },
      {
        textKey: 'MENU.NOTES',
        link: '/notes',
        icon: '',
        permissionsNeeded: [PERMISSIONS.ExecDashboardRead]
      },
      {
        textKey: 'MENU.CONFERENCES',
        link: '/conferences',
        icon: '',
        permissionsNeeded: [PERMISSIONS.ExecDashboardRead]
      },
      {
        textKey: 'MENU.SHORTINTEREST',
        link: '/short-interest',
        icon: '',
        permissionsNeeded: []
      },
      {
        textKey: 'MENU.REPORTS',
        link: '/reports',
        icon: '',
        permissionsNeeded: [PERMISSIONS.CoreAttachmentsRead]
      },
      {
        textKey: 'MENU.RESTRICTIONS',
        link: '/restrictions',
        icon: '',
        permissionsNeeded: [],
        permissionsLenient: [PERMISSIONS.TradeRestrictionRead, PERMISSIONS.BoardRestrictionRead, PERMISSIONS.TradeRestrictionLimitedRead]
      },
    ]
  },
  {
    textKey: 'MENU.MY_TOOLS',
    icon: 'caret-down',
    permissionsNeeded: [
      PERMISSIONS.CoreCompanyAlertRead,
      PERMISSIONS.CoreCompanyRead,
      PERMISSIONS.ReadEventLog,
      PERMISSIONS.CoreSpaceNoteRead,
      PERMISSIONS.CoreSpaceThesisRead
    ],
    subMenu: [
      {
        textKey: 'MENU.MY_ALERTS',
        link: '/my-alerts',
        icon: '',
        permissionsNeeded: [PERMISSIONS.CoreCompanyAlertRead]
      },
      {
        textKey: 'MENU.MY_COMPANIES',
        link: '/my-companies',
        icon: '',
        permissionsNeeded: [PERMISSIONS.CoreCompanyRead]
      },
      {
        textKey: 'MENU.MY_HISTORY',
        link: '/my-history',
        icon: '',
        permissionsNeeded: [PERMISSIONS.ReadEventLog]
      },
      {
        textKey: 'MENU.MY_DRAFTS',
        link: '/my-drafts',
        icon: '',
        permissionsNeeded: []
      },
      {
        textKey: 'MENU.ALL_DRAFTS',
        link: '/all-drafts',
        icon: '',
        permissionsNeeded: [PERMISSIONS.CoreAllDraftRead]
      },
      {
        textKey: 'MENU.BLACKBIRD',
        link: CONFIG.blackbirdServiceRequestUrl,
        icon: '',
        permissionsNeeded: []
      }
    ]
  },
  {
    textKey: 'MENU.ADMIN',
    icon: 'caret-down',
    permissionsNeeded: [
      PERMISSIONS.UserRead,
      PERMISSIONS.RoleRead,
      PERMISSIONS.UserGroupRead,
      PERMISSIONS.HolidayRead,
      PERMISSIONS.PasswordExpirationRead,
      PERMISSIONS.ReadAuditReports,
      PERMISSIONS.JobRead,
      PERMISSIONS.CurateTagsUpdate,
      PERMISSIONS.QrsUpdate,
      PERMISSIONS.QrsCreate,
      PERMISSIONS.QrsDelete,
      PERMISSIONS.DistributionListRead,
      PERMISSIONS.ReleaseNoteRead,
    ],
    subMenu: [
      {
        textKey: 'MENU.USERS',
        link: '/users',
        icon: '',
        permissionsNeeded: [PERMISSIONS.UserRead]
      },
      {
        textKey: 'MENU.DEFAULT_ROLES',
        link: '/roles',
        icon: '',
        permissionsNeeded: [PERMISSIONS.RoleRead]
      },
      {
        textKey: 'MENU.USER_GROUPS',
        link: '/user-group',
        icon: '',
        permissionsNeeded: [PERMISSIONS.UserGroupRead]
      },
      {
        textKey: 'MENU.DOMAINS',
        link: '/domain',
        icon: '',
        permissionsNeeded: [PERMISSIONS.DomainRead]
      },
      {
        textKey: 'MENU.HOLIDAY_MANAGEMENT',
        link: '/holiday',
        icon: '',
        permissionsNeeded: [PERMISSIONS.HolidayRead]
      },
      {
        textKey: 'MENU.DISTRIBUTION_LISTS',
        link: '/distribution-lists',
        icon: '',
        permissionsNeeded: [PERMISSIONS.DistributionListRead]
      },
      {
        textKey: 'MENU.RELEASE_NOTES',
        link: '/release-notes',
        icon: '',
        permissionsNeeded: [PERMISSIONS.ReleaseNoteRead]
      },
      {
        textKey: 'MENU.PASSWORD_EXPIRATION',
        link: '/password-expiration',
        icon: '',
        permissionsNeeded: [PERMISSIONS.PasswordExpirationRead]
      },
      {
        textKey: 'MENU.USER_REPORTS',
        link: '/user-reports',
        icon: '',
        permissionsNeeded: [PERMISSIONS.ReadAuditReports]
      },
      {
        textKey: 'MENU.DATA_MANAGEMENT',
        link: '/data-management',
        icon: '',
        permissionsNeeded: [PERMISSIONS.AdminReadContent]
      },
      {
        textKey: 'MENU.API_DOCS',
        link: '/system-admin/docs',
        icon: '',
        permissionsNeeded: [PERMISSIONS.DevDocumentationRead]
      },
      {
        textKey: 'MENU.SYSTEM_HEALTH',
        link: '/system-health',
        icon: '',
        permissionsNeeded: []
      },
      {
        textKey: 'MENU.MANAGE_TAGS',
        link: '/manage-tags',
        icon: '',
        permissionsNeeded: [PERMISSIONS.CurateTagsUpdate]
      },
      {
        textKey: 'MENU.MANAGE_QRS_LINKS',
        link: '/manage-links',
        icon: '',
        permissionsNeeded: [PERMISSIONS.QrsCreate, PERMISSIONS.QrsDelete, PERMISSIONS.QrsUpdate ]
      }
    ]
  },
  {
    textKey: 'MENU.ADD',
    icon: 'caret-down',
    permissionsNeeded: [
      PERMISSIONS.CoreCompanyCreate,
      PERMISSIONS.CoreIndicationsCreate,
      PERMISSIONS.CorePortfolioCreate,
      PERMISSIONS.CoreProductCreate
    ],
    subMenu: [
      {
        textKey: 'Company',
        clickHandler: 'openAddCompanyModal',
        icon: 'caret-down',
        permissionsNeeded: [PERMISSIONS.CoreCompanyCreate]
      },
      {
        textKey: 'Portfolio',
        clickHandler: 'openAddPortfolioModal',
        icon: 'caret-down',
        permissionsNeeded: [PERMISSIONS.CorePortfolioCreate]
      },
      {
        textKey: 'Product',
        clickHandler: 'openAddProductModal',
        icon: 'caret-down',
        permissionsNeeded: [PERMISSIONS.CoreProductCreate]
      },
      {
        textKey: 'Sonar',
        clickHandler: 'openAddCrmModal',
        icon: 'caret-down',
        permissionsNeeded: [PERMISSIONS.SonarCreate]
      }
    ]
  },
];
